import { render, staticRenderFns } from "./SwitchingAssetTypes.vue?vue&type=template&id=955c070c&scoped=true"
import script from "./SwitchingAssetTypes.vue?vue&type=script&lang=js"
export * from "./SwitchingAssetTypes.vue?vue&type=script&lang=js"
import style0 from "./SwitchingAssetTypes.vue?vue&type=style&index=0&id=955c070c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955c070c",
  null
  
)

export default component.exports